import React from "react";

function Tab2000() {
  return (
    <>
      <style>{`
      /* Technical Specification Table */
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }

      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        text-transform: capitalize;
        letter-spacing: 0.5px;
        margin-bottom: 20px;
        padding: 0;
      }

      .table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
        background: white;
      }

      .table-bordered {
        border: 1px solid #ddd;
      }

      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        line-height: 1.42857;
        font-size: 14px;
        color: #333;
      }

      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }

      .table tbody tr:nth-child(odd) {
        background-color: white;
      }

      .table tbody tr:last-child {
        background-color: #ddd;
      }

      .table td:first-child {
        font-weight: 500;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>
        {/* start: Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">2000 Tablets/hr Tablet Making Machine</h1>
                  <div className="tj-page-link">
                    <span>
                      <i className="fa-solid fa-home"></i>
                    </span>
                    <span>
                      <a href="/">Home</a>
                    </span>
                    <span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                    <span>
                      <span>2000 Tablets/hr Tablet Making Machine</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>
        {/* end: Breadcrumb Section */}

        {/* start: Blog Section */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">
              <div className="col-lg-8">
                <div className="post-details-wrapper">
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                  >
                    <img
                      src="assets/images/service/2000-tablets-hr-tablet-making-machine.webp"
                      alt="Images"
                    />
                  </div>
                  <h2 className="title title-anim">
                    Transforming Customer: Tailored Solutions for Experiences.
                  </h2>
                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      Recognize that exceptional customer experiences are at the
                      heart of every successful business. Our Customer
                      Experience Solutions are crafted to help you transform
                      every interaction your customers have with your brand into
                      a meaningful and positive experience. We believe that
                      understanding the customer journey and providing
                      personalized, seamless experiences can significantly
                      enhance customer loyalty, satisfaction, and lifetime
                      value.Our approach to customer experience is comprehensive
                      and data-driven.
                    </p>
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      Our approach to customer experience is comprehensive and
                      data-driven. We begin by assessing your current customer
                      touchpoints, identifying areas for improvement, and using
                      insights to develop strategies that meet your customers'
                      evolving needs. From optimizing digital platforms.
                    </p>
                  </div>
                  <div className="space-for-header"></div>
                  <div className="images-wrap">
                    <div className="row">
                      <div className="col-sm-6">
                        <div
                          className="image-box wow fadeInUp"
                          data-wow-delay=".3s"
                        >
                          <img
                            src="assets/images/service/2000-tablets-2.webp"
                            alt="Image"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="image-box wow fadeInUp"
                          data-wow-delay=".5s"
                        >
                          <img
                            src="assets/images/service/2000-tablets-3.webp"
                            alt="Image"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Technical Specification Table */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Machine Capacity</td>
                          <td>2000 Tablets/hr</td>
                        </tr>
                        <tr>
                          <td>Machine Type</td>
                          <td>GMP</td>
                        </tr>
                        <tr>
                          <td>Material</td>
                          <td>SS</td>
                        </tr>
                        <tr>
                          <td>Automation Grade</td>
                          <td>Automatic</td>
                        </tr>
                        <tr>
                          <td>Voltage</td>
                          <td>240V</td>
                        </tr>
                        <tr>
                          <td>Usage/Application</td>
                          <td>For Tablet Making</td>
                        </tr>
                        <tr>
                          <td>Frequency</td>
                          <td>50Hz</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">
                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>
                      <li>
                        <a
                          className="active"
                          href="/single-rotary-tablet-press"
                        >
                          Single Rotary Tablet Press
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href="/mini-tablet-press">
                          Mini Tablet Press
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href="/r-d-tablet-press">
                          R&D Tablet Press
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href="/multi-layer-tablet-press">
                          Multi Layer Tablet Press
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href="/lab-tablet-press">
                          ESG Consulting
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href="service-details.html">
                          Development Hub
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div
                    className="tj-sidebar-widget widget-feature-item wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div className="feature-box">
                      <div className="feature-content">
                        <h2 className="title">Modern</h2>
                        <span>Home Makeover</span>
                        <a
                          className="read-more feature-contact"
                          href="tel:8321890640"
                        >
                          <i className="fa-solid fa-phone"></i>
                          <span>+8 (321) 890-640</span>
                        </a>
                      </div>
                      <div className="feature-images">
                        <img
                          src="assets/images/service/service-ad.webp"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* end: Blog Section */}
      </main>
    </>
  );
}

export default Tab2000;
